module.exports = __webpack_public_path__ + "static/training-89363b7dff7c2ad50c86110f6b21d962.mp4";